module.exports = __webpack_public_path__ + "img/bg.9f1e106f.png";